

import { Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser";
import { IonContent, LoadingController, NavParams, Platform, PopoverController } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { BannerService } from "src/app/services/banner/banner.service";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { isUndefined } from "src/app/services/codeUtils";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CashierBase } from "../../cashier-base/cashier-base";
import { DepositMainLabels } from "../cashier-models/interfaces";
import { ECheckModel, IDebitModel } from "../cashier-models/models";

@Component({
  selector: "page-deposit-e-check",
  templateUrl: "deposit-e-check.html",
})
export class DepositECheckPage extends CashierBase implements OnInit {
  @ViewChild('Content') content: IonContent;
  public labels: DepositMainLabels;
  private error = null;
  
  private depositForm: FormGroup;
  
  private amount: string;
  private bonusCode: string;
  private bonusID: string;
  private accountList: AbstractControl;

  private selectedAccount: any;

  private accounts: Array<any> = [];

  public buttonDisabled: boolean = false;
  public ssnValue: string;

  public maxACHAccounts;

  constructor(
    //   protected logger: Logger,
      protected config: ConfigService,
      protected cashierProvider: CashierService,
      protected successMessageService: SuccessMessageService,
      protected events: EventsService,
      protected bannerProvider: BannerService,
      protected navParams: NavParams,
      protected utils: UtilsService,
      private contentProvider: CashierContentService,
      private navigator:Navigator) {

      super();
      this.labels = new ECheckModel();
      this.amount = navParams.get('amount');
      this.bonusCode = navParams.get('bonusCode');
      this.bonusID = navParams.get('bonusID');

      this.successMessageService.clearMessage();
      this.error = null;
  }

  ngOnInit() {
      this.maxACHAccounts = this.config.getConfig().FEATURE_ECHECK_NUM_ACCTS || 3;
      this.depositForm = new FormGroup(
          {
              accountList: new FormControl('', [Validators.required]),
          }
      )

      this.accountList = this.depositForm.get('accountList');

      this.onGetAccounts();
  }

  ionViewWillEnter(){
    this.contentProvider
    .getPageConfig("echeck")
    .then((response: DepositMainLabels) => {
      this.labels = response;
    });

  }
  ionViewDidLoad() {
      console.log('ionViewDidLoad DepositECheckPage');
  }

  onGetAccounts() {
      this.accounts = [];
      this.cashierProvider.callListAccounts().subscribe(
          (response: any) => {
              if (response && !!response.result) {
                  var tempAccounts: any = response.payload;
                  let i = 0;
                  for (let index in tempAccounts) {
                      if (tempAccounts[index].paymentTypeCode == "ACH") {
                          // adding the id to the object, so it gets selected
                          tempAccounts[index].id = i;
                          i++;
                          
                          this.accounts.push(tempAccounts[index]);
                          // do not allow SIN update in this case 
                          if (typeof tempAccounts[index].accountAdditionalInfo3 != 'undefined') {
                                  this.ssnValue = tempAccounts[index].accountAdditionalInfo3;
                          }
                      }
                  }
                  if(!!this.accounts[0]) this.selectedAccount = this.accounts[0].id;
                  
              }
          },
          (error) => {
              this.error = error;
          }
      );
  }

  onUseDifferentAccount() {
      //this.selectedAccount = "";
      this.navigator.navigateTo("DepositECheckAddPage", {multipleModals: true}, {amount: this.amount});
  }

  onDeposit( ) {
      this.buttonDisabled = true;
      this.successMessageService.clearMessage();
      this.error = null;
      

      let accountIndex: any = (!isUndefined(this.depositForm.get("accountList").value)) ? this.depositForm.get("accountList").value : "0";
      let depositFormObj: any = this.depositForm.value;

      depositFormObj.amount = this.amount;
      depositFormObj.bonusCode = this.bonusCode;
      if (this.bonusID != "") {
          depositFormObj.bonusID = this.bonusID;
      }

      depositFormObj.customerAccountID = this.accounts[accountIndex].customerAccountID;
      depositFormObj.currency_code = this.cashierProvider.customer.preferredCurrency.currencyCode;
      depositFormObj.payment_type_code = "ACH";

    //   this.logger.log("callDeposit request = ", depositFormObj);
      this.cashierProvider.callDeposit(depositFormObj).subscribe(
          (response: any) => {
              this.buttonDisabled = false;
              if (response && !!response.result ) {
                  /*let depositEventData = {
                      customerId: this.cashierProvider.customer.customerId,
                      amount: depositFormObj.amount,
                      transaction_id: response.payload.paymentRequestID,
                      paymentMethod: "ACH",
                      bonusCode: depositFormObj.bonusCode,
                      bonusID: depositFormObj.bonusID
                  }
                  setTimeout(() => this.events.publish('event:deposit', depositEventData), 2000);*/
                  setTimeout(() => this.bannerProvider.fetchAllBanners(), 1000);
                  this.navigator.navigateTo("DepositSuccessfulPage", {multipleModals: false}, {amount: this.amount});
              }
          },
          (error) => {
              this.buttonDisabled = false;
              // handle all deposit errors in base
              this.error = this.handleError(error);
            //   this.logger.log("callDeposit error = ", error);
              this.content.scrollToTop();
          }
      )

      this.error = null;
  }
  
  onBack = () => {
    if (!!this.navParams.get("navigateBackPage")) {
        let navigateBackPage = this.navParams.get("navigateBackPage");
        if(navigateBackPage == "default"){
          //Navigator.toLobby();
          this.navigator.navigateTo("CashierMainPage", { multipleModals: true });
        }else{
          this.navigator.navigateTo(navigateBackPage);
        }
      } else {
          this.navigator.back();
      }
  }
}
